
export const CLOUDY = 'cloudy';
export const SUN = 'day-sunny';
export const CLOUD = 'cloud';
export const RAIN = 'rain';
export const SNOW = 'snow';
export const WINDY = 'windy';
export const THUNDER = 'thunder';
export const DRIZZLE = 'drizzle';


// WEBPACK FOOTER //
// ./src/constant/weathers.js